(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class DrTopbar {
    constructor(root) {
      this.root = root;
      this.messages = Array.from(root.querySelectorAll('[data-dr-topbar-message]'));
      this.index = 0;
      const interval = parseInt(root.dataset.interval, 10);
      if (this.messages.length > 1 && interval > 0) {
        this.timer = setInterval(() => this.next(), interval);
      }
    }

    next() {
      this.messages[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].classList.add('is-active');
    }
  }

  function initDrTopbars() {
    document.querySelectorAll('[data-dr-topbar]').forEach((el) => {
      if (!el.dataset.drInit) {
        el.dataset.drInit = 'true';
        new DrTopbar(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initDrTopbars);
  document.addEventListener('shopify:section:load', initDrTopbars);
  initDrTopbars();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(list) {
      if (list.dataset.drInit) return;
      list.dataset.drInit = 'true';

      const section = list.closest('section') || document;
      const tabs = Array.from(list.querySelectorAll('[data-dr-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-dr-tabpanel]'));

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.drTab;
          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });
          panels.forEach((p) => {
            p.hidden = p.dataset.drTabpanel !== id;
          });
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-dr-tablist]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MOBILE = '(max-width: 767.98px)';

    function init() {
      document.querySelectorAll('[data-dr-footer-toggle]').forEach((btn) => {
        if (btn.dataset.drInit) return;
        btn.dataset.drInit = 'true';
        btn.addEventListener('click', () => {
          if (!window.matchMedia(MOBILE).matches) return;
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-header"]) return;
  try {
    
  (function () {
    function openLayer(el) {
      if (!el) return;
      el.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeLayer(el) {
      if (!el) return;
      el.hidden = true;
      document.body.style.overflow = '';
    }

    function init() {
      const searchLayer = document.querySelector('[data-dr-search-layer]');
      const drawer = document.querySelector('[data-dr-drawer]');

      document.querySelectorAll('[data-dr-search-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          openLayer(searchLayer);
          const input = searchLayer.querySelector('[data-dr-search-input]');
          if (input) input.focus();
        });
      });

      document.querySelectorAll('[data-dr-search-close]').forEach((btn) => {
        btn.addEventListener('click', () => closeLayer(searchLayer));
      });

      document.querySelectorAll('[data-dr-drawer-open]').forEach((btn) => {
        btn.addEventListener('click', () => openLayer(drawer));
      });

      document.querySelectorAll('[data-dr-drawer-close]').forEach((btn) => {
        btn.addEventListener('click', () => closeLayer(drawer));
      });

      document.querySelectorAll('[data-dr-accordion]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          const panel = btn.nextElementSibling;
          if (panel) panel.hidden = expanded;
        });
      });

      initMegaPreview();

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeLayer(searchLayer);
          closeLayer(drawer);
        }
      });
    }

    /*
      Mega menu hover preview: pointing at a link shows that collection's
      image. Bound per menu rather than on the document so one menu's hover
      cannot repaint another's panel, and reset on mouseleave so the panel
      goes back to the promo instead of keeping the last thing hovered.
    */
    function initMegaPreview() {
      document.querySelectorAll('.dr-megamenu').forEach((menu) => {
        const panel = menu.querySelector('[data-dr-megapreview]');
        if (!panel) return;

        const img = panel.querySelector('[data-dr-megapreview-img]');
        const title = panel.querySelector('[data-dr-megapreview-title]');
        const link = panel.querySelector('[data-dr-megapreview-link]');
        if (!img) return;

        const defaults = {
          src: panel.dataset.drDefaultImg || '',
          title: panel.dataset.drDefaultTitle || '',
          href: panel.dataset.drDefaultHref || '',
        };

        function show(src, text, href) {
          if (!src) {
            img.hidden = true;
            if (title) title.textContent = '';
            return;
          }
          img.hidden = false;
          // srcset would keep overriding src on a swap.
          img.removeAttribute('srcset');
          img.src = src;
          img.alt = text || '';
          if (title) title.textContent = text || '';
          if (link) link.href = href || '#';
        }

        const reset = () => show(defaults.src, defaults.title, defaults.href);
        reset();

        menu.querySelectorAll('[data-dr-megaimg]').forEach((a) => {
          a.addEventListener('mouseenter', () =>
            show(a.dataset.drMegaimg, a.dataset.drMegatitle, a.getAttribute('href'))
          );
          a.addEventListener('focus', () =>
            show(a.dataset.drMegaimg, a.dataset.drMegatitle, a.getAttribute('href'))
          );
        });

        menu.addEventListener('mouseleave', reset);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.drInit) return;
      root.dataset.drInit = 'true';

      const track = root.querySelector('[data-dr-hero-track]');
      const slides = Array.from(root.querySelectorAll('[data-dr-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-dr-hero-dot]'));
      if (!track || slides.length < 2) return;

      let index = 0;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        sync();
      }

      function sync() {
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(parseInt(dot.dataset.drHeroDot, 10)));
      });

      // Keep the dots honest when the user swipes the track directly.
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const nearest = slides.reduce((best, slide, i) => {
            const distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
            return distance < best.distance ? { i: i, distance: distance } : best;
          }, { i: 0, distance: Infinity });
          index = nearest.i;
          sync();
        }, 90);
      });

      const autoplay = parseInt(root.dataset.autoplay, 10);
      if (autoplay > 0) {
        let timer = setInterval(() => goTo(index + 1), autoplay);
        root.addEventListener('mouseenter', () => clearInterval(timer));
        root.addEventListener('mouseleave', () => {
          timer = setInterval(() => goTo(index + 1), autoplay);
        });
      }
    }

    function init() {
      document.querySelectorAll('[data-dr-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-main-collection"]) return;
  try {
    
  /*
    Push-layout toggle and live filtering. Kept separate from the drawer
    script below: the push sidebar stays in the document flow and only toggles
    a class, it never hides the panel with the hidden attribute.
  */
  (function () {
    function initPush() {
      const root = document.querySelector('[data-dr-collection]');
      if (!root) return;
      // Init can run more than once on the same element - the editor and the
      // dev server's hot reload both fire shopify:section:load. A toggle bound
      // twice flips twice per click and appears to do nothing at all.
      if (root.dataset.drPushReady) return;
      root.dataset.drPushReady = '1';
      const toggles = root.querySelectorAll('[data-dr-filter-toggle]');
      const opener = root.querySelector('.dr-collection__filter-by');

      function set(open) {
        root.classList.toggle('is-filters-open', open);
        if (opener) opener.setAttribute('aria-expanded', String(open));
        document.body.style.overflow =
          open && window.matchMedia('(max-width: 991.98px)').matches ? 'hidden' : '';
      }

      toggles.forEach((btn) => {
        btn.addEventListener('click', () => set(!root.classList.contains('is-filters-open')));
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && root.classList.contains('is-filters-open')) set(false);
      });

      // The reference applies a filter the moment it is chosen; there is no
      // Apply button. Price waits for the user to stop typing.
      root.querySelectorAll('form.dr-filters').forEach((form) => {
        let timer;
        form.addEventListener('change', (e) => {
          clearTimeout(timer);
          const delay = e.target.type === 'number' ? 700 : 0;
          timer = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), delay);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPush);
    } else {
      initPush();
    }
    document.addEventListener('shopify:section:load', initPush);
  })();

  (function () {
    function init() {
      // Sort submits as soon as it changes.
      document.querySelectorAll('[data-dr-sort] select').forEach((select) => {
        if (select.dataset.drInit) return;
        select.dataset.drInit = 'true';
        select.addEventListener('change', () => select.form.submit());
      });

      const panel = document.querySelector('[data-dr-filter-panel]');
      if (!panel) return;

      // The push layout runs its own toggle above and shows or hides the panel
      // with a class. Left to this script, the push panel was picked up as a
      // sidebar and given the hidden attribute on phones, so it opened at zero
      // width.
      if (panel.classList.contains('dr-collection__aside--push')) return;

      // The sidebar layout is visible on desktop and only hides behind the
      // toggle once the media query turns it into an overlay.
      const isDrawer = panel.classList.contains('dr-collection__drawer');
      const MOBILE = '(max-width: 991.98px)';

      function setHidden(hidden) {
        if (isDrawer || window.matchMedia(MOBILE).matches) {
          panel.hidden = hidden;
          document.body.style.overflow = hidden ? '' : 'hidden';
        }
      }

      if (!isDrawer && window.matchMedia(MOBILE).matches) panel.hidden = true;

      document.querySelectorAll('[data-dr-filter-open]').forEach((btn) => {
        btn.addEventListener('click', () => setHidden(false));
      });

      document.querySelectorAll('[data-dr-filter-close]').forEach((btn) => {
        btn.addEventListener('click', () => setHidden(true));
      });

      window.addEventListener('resize', () => {
        if (!isDrawer && !window.matchMedia(MOBILE).matches) {
          panel.hidden = false;
          document.body.style.overflow = '';
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setHidden(true);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
